import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ResponseType } from '../../interfaces/response';
import Styles from '../../styles/common/common.module.css';
import { resetMessage } from '../../stores/common/message-slice';

function AlertToast() {
  const dispatch = useDispatch();
  const messageStore = useSelector((state: any) => state.messages);

  useEffect(() => {
    const successToastOptions: ToastOptions = {
      position: 'bottom-center',
      className: Styles.toastCustom,
      bodyClassName: Styles.toastCustomBody,
      progressClassName: Styles.toastCustomProgress,
      toastId: messageStore?.message || "global-success-message",
      onClose: () => {
        dispatch(resetMessage());
      },
    };

    const errorToastOptions: ToastOptions = {
      position: 'bottom-center',
      className: Styles.toastError,
      bodyClassName: Styles.toastErrorBody,
      progressClassName: Styles.toastErrorProgress,
      toastId: messageStore?.error || "global-error-message",
      onClose: () => {
        dispatch(resetMessage());
      },
    };

    // Show success toast if the message is set and status is success
    if (messageStore && messageStore.status === ResponseType.Success && messageStore.message) {
      toast.success(messageStore.message, successToastOptions);
    }

    // Show error toast if there is an error message
    if (messageStore && messageStore.status === ResponseType.Failed && messageStore.error) {
      toast.error(messageStore.error, errorToastOptions);
    }

  }, [messageStore, dispatch]);

  return null;
}

export default AlertToast;
